import { render, staticRenderFns } from "./VBTableNew.vue?vue&type=template&id=3d6c3503&scoped=true&"
import script from "./VBTableNew.vue?vue&type=script&lang=js&"
export * from "./VBTableNew.vue?vue&type=script&lang=js&"
import style0 from "./VBTableNew.vue?vue&type=style&index=0&id=3d6c3503&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6c3503",
  null
  
)

export default component.exports